var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:{ disabled: _vm.isDisabled },on:{"click":function($event){return _vm.onClick()}}},[_c('i',{class:_vm.icon,attrs:{"title":_vm.$t(_vm.label)}}),(_vm.showButtonName)?_c('span',{staticClass:"ml-1"},[_vm._v(_vm._s(_vm.$t(_vm.label)))]):_vm._e(),(_vm.busy)?_c('b-spinner',{attrs:{"small":""}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }